/**Dependencies */
import React, { useEffect, useRef, useState } from "react";

/**Components */
import {
  Row,
  Col,
  Image,
  Button,
  Tab,
  Card,
  Nav,
  Collapse,
  Container,
  Modal,
} from "react-bootstrap";
import { CardCarrousel } from "../components/CardCarrousel";
import Slider from "react-slick";
import { FaInfoCircle, FaListAlt, FaStar } from "react-icons/fa";
import { settingsInfoHotel } from "../utils";
import { SearchEngine } from "../components/SearchEngine";
import { CheckOutCart } from "../components/CheckOutCart";

/**Styles */
import "../styles/hotel.scss";

/**Images */
import imgSirenis from "../images/img-sirenis.png";
import imgRoyalton from "../images/img-royalton.png";
import imgRiu from "../images/img-riu.png";
import hotel1 from "../images2/imagen-hotel1.png";
import hotel2 from "../images2/imagen-hotel2.png";
import hotel3 from "../images2/imagen-hotel3.png";
import { FaChild, FaMale } from "react-icons/fa";
import { MdCheck, MdOutlineCancel } from "react-icons/md";
import bannerAyuda from "../images2/banner-ayuda-desktop.png";
import { BsFillTelephoneFill } from "react-icons/bs";
import { FaPhoneVolume } from "react-icons/fa6";
import {
  getHotelAvailability,
  getHotelesRate,
  getHotelesRateHdo,
  getHotelesRatePtc,
  getHotels,
  getSimilarDestinations,
} from "../services/searchService";
import {
  Currency,
  fetchMarkup,
  FormatCancellationPolicies,
  FormatDate,
  totalPrices,
} from "../helpers";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { GalleryInfo } from "../components/GalleryInfo";
import { getActivePDP } from "../services/checkoutService";
import { Loader } from "../components/Loader";
import { GeneralForm } from "../components/GeneralForm";
import { comisionUser } from "../services/LoginService";
import Skeleton from "react-loading-skeleton";
import { ScrollToTopRoute } from "../components/ScrollToTopRoute";
import imgPreview from "../images/image-preview.jpg";
export const InfoHotel = () => {
  const [comisionUsuario, setComisionUsuario] = useState(0);
  const [userData] = useState(
    JSON.parse(localStorage.getItem("dataUser") || 0)
  );
  const [destinies] = useState([
    {
      hotel: "Grand Sirenis Punta Cana Resort & Aquagames",
      location: "Punta Cana, Rep. Dom.",
      price: "$000,000",
      days: "10",
      img: imgSirenis,
    },
    {
      hotel: "Royalton Splash",
      location: "Cancún, México",
      price: "$000,000",
      days: "10",
      img: imgRoyalton,
    },
    {
      hotel: "Riu República",
      location: "Punta Cana, Rep. Dom.",
      price: "$000,000",
      days: "10",
      img: imgRiu,
    },
  ]);
  const location = useLocation();
  const navigate = useNavigate();
  // Función para parsear los parámetros de la URL
  const parseQueryParams = (query) => {
    return Object.fromEntries(new URLSearchParams(query));
  };
  const [show, setShow] = useState(false);

  const queryParams = parseQueryParams(location?.search);
  const [hideSearchDestination, setHideSearchDestination] = useState("none");
  const [selectedDates, setSelectedDates] = useState([]);
  const [hidePaxSelection, setHidePaxSelection] = useState("none");
  let requestData = [];
  let img;
  const [totalRooms, setTotalRooms] = useState([]);
  const [addRoomLoader, setAddRoomLoader] = useState(null);
  const [rooms, setRooms] = useState([]);
  const [nameDestination, setNameDestination] = useState("");
  const [totalPersons, setTotalPersons] = useState([]);
  const [loading, setLoading] = useState(true); // Indicador de carga
  const [hotels, setHotels] = useState([]); // Estado para los hoteles
  const [rates, setRates] = useState([]); // Estado para los hoteles
  const [similarHoteles, setSimilarHoteles] = useState([]);
  const [nights, setNights] = useState(0);
  const [timeNights, setTimeNights] = useState();
  const [markup, setMarkup] = useState("");
  const [pdp, setPdp] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [arrSession, setArrSession] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva"))
  );
  const [openTab, setOpenTab] = useState("description");

  useEffect(() => {
    window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup("hoteleria");
        setMarkup(markupData?.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);
  /* const roomsRef = useRef(null);

   useEffect(() => {
    if (rates && rates.length && roomsRef.current) {
      roomsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [rates]);  */
  useEffect(() => {
    const pasarelaActiva = async () => {
      try {
        const pasarela = await getPdp();
        setPdp(pasarela);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    pasarelaActiva();
  }, []);

  useEffect(() => {
    const comision = async () => {
      try {
        if (userData?.usuario?.id) {
          const response = await comisionUser(userData?.usuario?.id);
          setComisionUsuario(response);
        } else {
          setComisionUsuario(0);
        }
      } catch (error) {
        throw new Error("error connection: " + error);
      }
    };

    comision();
  }, []);

  const getPdp = async () => {
    try {
      const response = await getActivePDP();
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  /**
   * Función para manejar el envío del formulario de contacto,
   * esta función se encarga de tomar los datos del formulario,
   * llamar al servicio para enviar el correo y mostrar un mensaje
   * de success o error dependiendo del resultado.
   *
   * @returns {Promise<void>}
   */

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const construirRequest = () => {
    // Extraemos los parámetros de la URL
    const checkInDate = queryParams?.in;
    const checkOutDate = queryParams?.out;
    const id = queryParams?.idHotel; // ID del destino
    const tipo = queryParams?.t || "alojamiento"; // Tipo de alojamiento
    setSelectedDates([checkInDate, checkOutDate]);
    // Crear habitaciones a partir de los parámetros pax
    const habitaciones = Object.keys(queryParams)
      ?.filter((key) => key?.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      ?.map((key) => {
        const [adultos, menores, edades] = queryParams[key].split("|");
        return {
          num_adultos: parseInt(adultos, 10),
          num_menores: parseInt(menores, 10),
          edad_menores: edades ? edades?.replace(/,/g, "|") : "", // Convertimos comas en pipes
        };
      });
    const habitacionesFormatted = Object.keys(queryParams)
      ?.filter((key) => key?.startsWith("pax")) // Filtramos las claves que empiezan con 'pax'
      ?.map((key, index) => {
        const [adultos, menores, edades] = queryParams[key].split("|");

        // Convertir edades (si las hay) en un array
        const edadesArray =
          edades === "0" || !edades ? [] : edades?.split(",")?.map(Number);

        // Devolver el objeto con la estructura requerida
        return {
          room: index + 1, // El número de la habitación es el índice + 1
          adults: parseInt(adultos, 10),
          minors: parseInt(menores, 10),
          ages: edadesArray,
        };
      });

    setRooms(habitacionesFormatted);
    setTotalRooms(habitaciones);
    // Construir el objeto final
    const request = {
      fechas: {
        checkin: checkInDate,
        checkout: checkOutDate,
      },
      alojamiento: {
        id: id,
        tipo: tipo,
      },
      habitaciones,
    };
    const requestSimilarDestinations = {
      fechas: {
        checkin: checkInDate,
        checkout: checkOutDate,
      },
      idHotel: id,
      habitaciones,
    };

    return [request, requestSimilarDestinations];
  };

  useEffect(() => {
    requestData = construirRequest(); // Esto solo se ejecuta cuando `location.search` cambia
  }, [location.search]);

  useEffect(() => {
    const totalPax = () => {
      const adultos = totalRooms?.map((adulto) => adulto?.num_adultos);
      const menores = totalRooms?.map((menor) => menor?.num_menores);
      const sumAdultos = adultos?.reduce((adulto, index) => adulto + index, 0);
      const sumMenores = menores?.reduce((menor, index) => menor + index, 0);

      return {
        menores: sumMenores,
        adultos: sumAdultos,
      };
    };
    setTotalPersons(totalPax());
  }, [rates]);

  useEffect(() => {
    // Obtener la URL actual
    const queryParams = parseQueryParams(location.search);

    // Obtener las fechas de entrada y salida de la URL
    const checkInDate = queryParams.in;
    const checkOutDate = queryParams.out;

    if (checkInDate && checkOutDate) {
      const checkIn = new Date(checkInDate);
      const checkOut = new Date(checkOutDate);
      const timeDifference = checkOut - checkIn;
      const totalNights = timeDifference / (1000 * 3600 * 24);

      setNights(totalNights);
    }

    const dataNight = [checkInDate, checkOutDate];

    setTimeNights(dataNight);
  }, [location.search]);
  const fetchHotels = async () => {
    try {
      const response = await getHotels(requestData[0]);
      return response;
    } catch (error) {
      console.error("Error fetching hotels:", error);
      return [];
    }
  };

  const fetchRates = async () => {
    try {
      const response = await getHotelAvailability(requestData[0]);
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const fetchDestinations = async () => {
    try {
      const response = await getSimilarDestinations(requestData[1]);
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const hotelsData = await fetchHotels();
        const ratesData = await fetchRates();
        const destinations = await fetchDestinations();
        setNameDestination(hotelsData?.[0]?.destino);
        setHotels(hotelsData);
        setRates(ratesData);
        setLoading(false);
        setSimilarHoteles(destinations);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  const getStarCount = (categoria) => {
    const starMatch = categoria?.match(/^(\d+)/); // Busca el número al inicio de la cadena
    return starMatch ? parseInt(starMatch[1], 10) : 0; // Devuelve el número de estrellas
  };

  const HotelStars = ({ categoriaId }) => {
    const totalStars = 5; // Siempre queremos mostrar 5 estrellas
    const starCount = getStarCount(categoriaId); // Obtener el número de estrellas activas
    // Crear un arreglo de 5 estrellas, donde las primeras `starCount` sean destacadas y el resto en gris
    const stars = Array.from({ length: totalStars }, (_, index) =>
      index < starCount ? (
        <FaStar style={{ color: " #0044aa" }} key={index} />
      ) : (
        <FaStar style={{ color: " #000000ff" }} />
      )
    );

    return <div className="section-stars">{stars}</div>;
  };

  const actualizarDatos = async (
    arrData,
    dataName,
    dataNameHotel,
    dataDestino,
    dates,
    pax,
    dataCategoria,
    dataId,
    dataMoneda,
    dataIdHab,
    dataCodePais,
    imgHab,
    nights,
    numHabitaciones,
    urlHotel,
    totalPrices,
    totalApi,
    politicasCancelacion,
    codigoDestino,
    index,
    dataResultadoDisponibilidad
  ) => {
    sessionStorage.removeItem("datosReservaPP");
    try {
      setAddRoomLoader(dataIdHab + "-" + index);

      const request =
        arrData?.idApi === "bol"
          ? {
              habitaciones: [
                {
                  rateKey: arrData?.rateKey,
                },
              ],
            }
          : {
              codigopais: dataCodePais,
              moneda: dataMoneda,
              ratekey: arrData?.MealPlans.MealPlan.RateDetails[0]?.RateKey,
              checkin: dates?.[0],
              checkout: dates?.[1],
              codehotel: rates?.[1]?.hdo?.id,
              codigohab: arrData?.Id,
              idmealplan: arrData?.MealPlans?.MealPlan?.Id,
              totalhab: totalRooms?.length,
              totalPaxes: totalRooms,
            };

      let checkRateResponse = "";
      let checkRateResponsePtc = "";
      let checkRateResponseHdo = "";

      if (arrData?.idApi === "bol") {
        checkRateResponse = await getHotelesRate(request);
        arrData.rateKey = checkRateResponse.habitacion.rates[0].rateKey;
        window.dispatchEvent(new CustomEvent("cartUpdated"));
        window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
      } else if (arrData?.idApi === "pct") {
        checkRateResponsePtc = await getHotelesRatePtc(request);
        arrData.rateKey = checkRateResponsePtc.bookingKey;
        window.dispatchEvent(new CustomEvent("cartUpdated"));
        window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
      } else if (arrData?.idApi !== "bol") {
        checkRateResponseHdo = await getHotelesRateHdo(request);
        arrData.rateKey = checkRateResponseHdo.room.MealPlans.MealPlan.RateKey;
        window.dispatchEvent(new CustomEvent("cartUpdated"));
        window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
      }

      let fechaExpiracion;

      const ahora = new Date();

      const datosPrevios = JSON.parse(
        sessionStorage.getItem("datosReserva")
      ) || {
        hospedaje: [],
        actividades: [],
        traslados: [],
      };

      if (datosPrevios?.hospedaje?.length === 0) {
        fechaExpiracion = new Date(ahora.getTime() + 7 * 60 * 1000);
      } else {
        // Usar la fecha de expiración existente de la primera habitación
        fechaExpiracion = new Date(
          datosPrevios?.hospedaje?.[0]?.fechaExpiracion
        );
      }

      if (arrData?.idApi === "bol") {
        if (!checkRateResponse?.habitacion?.rates?.[0]?.rateKey) {
          setAddRoomLoader(false);
          Swal.fire({
            title: "Disponibilidad cambiada",
            text: "Los precios o disponibilidad han cambiado. Por favor verifica nuevamente.",
            icon: "error",
            confirmButtonText: "Entendido",
            customClass: { confirmButton: "btn-purple w-auto" },
          });
          return;
        }
      } else if (arrData?.idApi !== "bol") {
        if (!checkRateResponseHdo?.room?.MealPlans?.MealPlan?.RateKey) {
          setAddRoomLoader(false);
          Swal.fire({
            title: "Disponibilidad cambiada",
            text: "Los precios o disponibilidad han cambiado. Por favor verifica nuevamente.",
            icon: "error",
            confirmButtonText: "Entendido",
            customClass: { confirmButton: "btn-purple w-auto" },
          });
          return;
        }
      }

      const nuevasHabitaciones = Array.from(
        { length: numHabitaciones },
        () => ({
          nombreHotel: dataNameHotel,
          destino: dataDestino,
          codeHotel: rates?.[1]?.hdo?.id,
          idMealPlan: arrData?.MealPlans?.MealPlan?.Id,
          estatus: arrData?.MealPlans?.MealPlan?.Available?.Status,
          nombreHab: dataName,
          checkIn: dates?.[0],
          checkOut: dates?.[1],
          paxes: pax,
          direccionHotel: rates?.[0]?.bol?.zona,
          api: arrData?.idApi === "bol" ? "bol" : "hdo",
          categoriaHotel: dataCategoria,
          id_atv3: dataId,
          moneda: dataMoneda,
          codigoHab: dataIdHab,
          codigoPais: dataCodePais,
          img: imgHab,
          noches: nights,
          precio:
            arrData?.total ||
            checkRateResponseHdo?.room?.MealPlans?.MealPlan?.Total,
          totalPrices: totalPrices,
          precioApi: totalApi,
          adultos: pax?.[0]?.num_adultos,
          menores: pax?.[0]?.num_menores,
          edades: pax?.[0]?.edad_menores != "" ? pax?.[0]?.edad_menores : [0],
          nombrePlan: arrData?.planAlimenticio,
          cancellationText: politicasCancelacion,
          codedestino: codigoDestino,
          totalPaxes: totalRooms,
          fechaAgregado: ahora?.toISOString(),
          fechaExpiracion: fechaExpiracion?.toISOString(), // Misma para todas
          rateComments:
            arrData?.idApi === "pct"
              ? checkRateResponsePtc?.comentarios
              : checkRateResponse?.habitacion?.rates?.[0]?.rateComments,
          ...arrData,
        })
      );

      const nuevasUrl = Array.from({ length: numHabitaciones }, () => ({
        urlHotel: urlHotel,
      }));

      setAddRoomLoader(false);

      const totalHabitaciones =
        datosPrevios?.hospedaje?.length + numHabitaciones;

      if (totalHabitaciones > rooms?.length) {
        Swal.fire({
          title: "Máximo de habitaciones solicitadas",
          text: "Haz agregado el máximo de habitaciones solicitadas.",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Continuar con la reservación",
          cancelButtonText: "Cancelar esta habitación",
          denyButtonText: "Reemplazar habitación",
          customClass: {
            confirmButton: "btn-purple w-auto",
            denyButton: "btn-purple w-auto",
          },
          preConfirm: () => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Continuar con la reservación
            window.dispatchEvent(new CustomEvent("cartUpdated"));
            window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
            navigate("/preventa");
          } else if (result.isDenied) {
            const hospedajeActualizado = datosPrevios?.hospedaje?.slice(0, -1);

            // Asegurarnos de que nuevasHabitaciones es un array y tomar la primera habitación
            const habitacionAReemplazar = Array.isArray(nuevasHabitaciones)
              ? nuevasHabitaciones[0]
              : nuevasHabitaciones;

            // Crear el nuevo array con la habitación reemplazada
            const nuevoHospedaje = [
              ...hospedajeActualizado,
              habitacionAReemplazar,
            ];

            // Preparar los datos actualizados
            const setDatos = {
              idPasarela: pdp?.nombre,
              hospedaje: nuevoHospedaje,
              actividades: datosPrevios?.actividades,
              traslados: datosPrevios?.traslados,
              // url: [...datosPrevios?.url, ...nuevasUrl].slice(
              //   0,
              //   nuevoHospedaje?.length
              // ),
            };
            // Actualizar el sessionStorage
            sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
            window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
            sessionStorage.setItem("datosURL", JSON.stringify(setDatos?.url));
            window.dispatchEvent(new CustomEvent("cartUpdated"));
            // Actualizar los estados
            setShowAlert(true);
            setArrSession(setDatos);
          }
        });
        return;
      } else {
        const nuevasHabitaciones = Array.from(
          { length: numHabitaciones },
          () => ({
            nombreHotel: dataNameHotel || rates?.[0]?.bol?.nombre,
            destino: dataDestino || rates?.[0]?.bol?.destino,
            nombreHab: dataName || arrData?.Name,
            checkIn: dates?.[0],
            checkOut: dates?.[1],
            paxes: pax,
            direccionHotel: rates?.[0]?.bol?.zona,
            codeHotel: rates?.[1]?.hdo?.id,
            idMealPlan: arrData?.MealPlans?.MealPlan?.Id,
            estatus: arrData?.MealPlans?.MealPlan?.Available?.Status,
            api: arrData?.idApi === "bol" ? "bol" : "hdo",
            categoriaHotel: dataCategoria || rates?.[0]?.bol?.categoria,
            id_atv3: dataId,
            moneda: dataMoneda || rates?.[0]?.bol?.moneda,
            codigoHab: dataIdHab,
            codigoPais: dataCodePais,
            img: imgHab,
            noches: nights,
            precio:
              arrData?.total ||
              checkRateResponseHdo?.room?.MealPlans?.MealPlan?.Total,
            totalPrices: totalPrices,
            precioApi: totalApi,
            totalPaxes: totalRooms,
            adultos: pax?.[0]?.num_adultos,
            menores: pax?.[0]?.num_menores,
            edades: pax?.[0]?.edad_menores != "" ? pax?.[0]?.edad_menores : [0],
            nombrePlan:
              arrData?.planAlimenticio || arrData?.MealPlans?.MealPlan?.Name,
            cancellationText: politicasCancelacion,
            codedestino: codigoDestino,
            fechaAgregado: ahora?.toISOString(),
            fechaExpiracion: fechaExpiracion?.toISOString(), // Misma para todas
            rateComments:
              arrData?.idApi === "bol"
                ? checkRateResponse?.habitacion?.rates?.[0]?.rateComments
                : checkRateResponsePtc?.comentarios,
            ...arrData,
          })
        );

        const nuevoHospedaje = [
          ...datosPrevios.hospedaje,
          ...nuevasHabitaciones,
        ];
        const setDatos = {
          idPasarela: pdp?.nombre,
          hospedaje: nuevoHospedaje,
          actividades: datosPrevios?.actividades,
          traslados: datosPrevios?.traslados,
          url: Array.from({ length: numHabitaciones }, () => ({ urlHotel })),
          lastUpdate: ahora?.toISOString(),
        };

        sessionStorage.setItem("datosReserva", JSON.stringify(setDatos));
        window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
        sessionStorage.setItem("datosURL", JSON.stringify(setDatos.url));
        window.dispatchEvent(new CustomEvent("cartUpdated"));
        setShowAlert(true);
        setArrSession(setDatos);

        // Solo iniciar temporizador si es la primera habitación
        if (datosPrevios?.hospedaje?.length === 0) {
          iniciarTemporizador(fechaExpiracion);
          window.dispatchEvent(new CustomEvent("sessionStorageUpdated"));
          window.dispatchEvent(new CustomEvent("cartUpdated"));
        }
      }
    } catch (error) {
      console.error("Error en actualizarDatos:", error);
      setAddRoomLoader(false);
      Swal.fire({
        title: "Error",
        text: "Ocurrió un error al verificar la disponibilidad.",
        icon: "error",
        confirmButtonText: "Entendido",
      });
    } finally {
      setAddRoomLoader(false);
    }
  };

  // Función para manejar el temporizador global
  let temporizadorGlobal = null;

  function iniciarTemporizador(fechaExpiracion) {
    // Limpiar temporizador anterior si existe
    if (temporizadorGlobal) {
      clearTimeout(temporizadorGlobal);
    }

    const ahora = new Date();
    const tiempoRestante = fechaExpiracion - ahora;

    if (tiempoRestante > 0) {
      temporizadorGlobal = setTimeout(() => {
        // Mostrar alerta
        Swal.fire({
          title: "Tiempo agotado",
          text: "Tu sesión de reserva ha expirado. Por favor inicia nuevamente.",
          icon: "warning",
          confirmButtonText: "Entendido",
        });

        // Limpiar sessionStorage
        sessionStorage.removeItem("datosReserva");
        sessionStorage.removeItem("datosURL");

        // Actualizar estado
        setArrSession(null);
        setShowAlert(false);

        // Opcional: Redirigir
        navigate("/");
      }, tiempoRestante);
    }
  }

  const toggleTab = (key) => {
    setOpenTab(openTab === key ? null : key);
  };
  return (
    <div>
      {loading && (
        <>
          <Loader />
          <ScrollToTopRoute />
        </>
      )}
      <div className="section-gallery container py-4">
        <div className="w-100 d-lg-flex d-md-flex align-items-start">
          <h4 style={{ color: "#01388aff", fontSize: "30px" }}>
            {rates?.length ? (
              <>{hotels?.[0]?.nombre} </>
            ) : (
              <Skeleton width={500} height={30} />
            )}
          </h4>
          <p
            className="m-0 ms-0 ms-md-3 ms-lg-3 stars-cat"
            style={{ fontSize: "20px" }}
          >
            {rates?.[0]?.bol?.categoria === "BOUTIQUE" ? (
              <>{rates?.[0]?.bol?.categoria}</>
            ) : (
              <HotelStars categoriaId={rates?.[0]?.bol?.categoria} />
            )}
          </p>
        </div>
        <p
          className="text-secondary pb-3"
          style={{ borderBottom: "1px solid #6e6e6e" }}
        >
          {hotels?.[0]?.direccion}
        </p>
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="Galeria"
          onSelect={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <Row>
            <Col sm={12}>
              <Tab.Content>
                <Tab.Pane eventKey="Galeria">
                  {" "}
                  <Row>
                    {hotels.map((hotel) => (
                      <GalleryInfo
                        images={hotel.imagenes}
                        alt={imgPreview}
                        isHotel={true}
                        urlImg={"http://photos.hotelbeds.com/giata/bigger/"}
                      />
                    ))}
                    <Col lg={3} md={4} sm={12} className="order-1  order-lg-0">
                      <SearchEngine
                        isInfoService={true}
                        isModify={true}
                        modifyHotel={"hotel"}
                        hotelId={queryParams.idHotel}
                        isHotel={true}
                        isExperiencias={false}
                        hideDestinations={true}
                        showDestinations={hideSearchDestination}
                        setShowDestinatios={setHideSearchDestination}
                        selectedDates={selectedDates}
                        hidePax={hidePaxSelection}
                        PaxSelection={setHidePaxSelection}
                        totalRooms={totalRooms}
                        arrayRooms={rooms}
                        totalPersons={[]}
                        destination={nameDestination}
                        alojamientos={true}
                        isInfoHotel={true}
                        isModifyHotel={true}
                      />
                    </Col>
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="Mapa">
                  {" "}
                  {hotels.map((hotel) => (
                    <iframe
                      title="Mapa del hotel"
                      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCPH50UmrLwDaIBrtOsq2Kig6xR_cHl1dw&q=${hotel.latitud},${hotel.longitud}&zoom=15`}
                      allowFullScreen
                      style={{ width: "100%", height: "626px" }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  ))}
                </Tab.Pane>
                <Tab.Pane eventKey="StreetView">
                  {" "}
                  {hotels.map((hotel) => (
                    <iframe
                      title="Streetview del hotel"
                      src={`https://www.google.com/maps/embed/v1/streetview?key=AIzaSyCPH50UmrLwDaIBrtOsq2Kig6xR_cHl1dw&location=${hotel.latitud},${hotel.longitud}`}
                      allowFullScreen
                      style={{ width: "100%", height: "626px" }}
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                  ))}
                </Tab.Pane>
              </Tab.Content>
            </Col>
            <Col sm={12}>
              <Nav className="d-flex mt-3 order-0 order-lg-1 mb-lg-0 mb-4 justify-content-md-start justify-content-center justify-content-lg-start">
                <Nav.Item>
                  <Nav.Link
                    className="btn-blue"
                    style={{
                      width: "115px",
                      borderRadius: "15px",
                      color: "#fff",
                    }}
                    eventKey="Galeria"
                  >
                    Galería
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="btn-blue mx-2"
                    style={{
                      width: "115px",
                      borderRadius: "15px",
                      color: "#fff",
                    }}
                    eventKey="Mapa"
                  >
                    Mapa
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    className="btn-blue"
                    style={{
                      width: "115px",
                      borderRadius: "15px",
                      color: "#fff",
                    }}
                    eventKey="StreetView"
                  >
                    StreetView
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
          </Row>
        </Tab.Container>
      </div>
      <div className="section-availables-rooms container text-start">
        <h1 className="title-blue">
          {rates?.length ? (
            <>
              Habitaciones disponibles:{" "}
              {rates?.[0]?.bol?.habitaciones?.length &&
              rates?.[1]?.hdo?.room?.length
                ? rates?.[0]?.bol?.habitaciones?.length +
                  rates?.[1]?.hdo?.room?.length
                : !rates?.[0]?.bol?.habitaciones?.length &&
                  rates?.[1]?.hdo?.room?.length
                ? rates?.[1]?.hdo?.room?.length
                : rates?.[0]?.bol?.habitaciones?.length &&
                  !rates?.[1]?.hdo?.room?.length
                ? rates?.[0]?.bol?.habitaciones?.length
                : 0}{" "}
            </>
          ) : (
            <Skeleton width={400} height={30} />
          )}
        </h1>
        {rates?.length ? (
          <>
            {Array.from({
              length: Math.max(
                rates?.[0]?.bol?.habitaciones?.length || 0,
                rates?.[1]?.hdo?.room?.length || 0
              ),
            }).map((_, index) => {
              const habBol = rates?.[0]?.bol?.habitaciones?.[index];
              const habHdo = rates?.[1]?.hdo?.room?.[index];
              let politicasTextHdo = "";
              habHdo?.MealPlans?.MealPlan?.RateDetails?.forEach((policy) => {
                politicasTextHdo += `<strong>Fecha de cancelación:</strong> ${
                  policy?.CancellationPolicy?.NoShow?.DateFrom
                } <br/>
                                                        <strong>Monto de penalidad:</strong> ${Currency(
                                                          policy
                                                            ?.CancellationPolicy
                                                            ?.NoShow?.Amount
                                                        )} <br/><br/>`;
              });
              // Imagen de BOL
              img = habBol
                ? hotels?.[0]?.imagenes?.find(
                    (hotelHab) =>
                      hotelHab?.id_tipo_foto === 2 &&
                      hotelHab?.tipo_habitacion === habBol?.code
                  )?.url ?? hotels?.[0]?.imagenes?.[0]?.url
                : null;

              const imgHdo = habHdo ? habHdo.Image : null;
              return (
                <React.Fragment key={index}>
                  {habBol && (
                    <div className="" key={index}>
                      <Card className="shadow-box mt-2 p-2">
                        {habBol?.rates?.map((rate, index) => {
                          let politicasText = "";
                          rate?.politicas?.forEach((policy) => {
                            politicasText += `<strong>Fecha de cancelación:</strong> ${FormatCancellationPolicies(
                              policy?.from
                            )} <br/>
                                                            <strong>Monto de penalidad:</strong> ${Currency(
                                                              policy?.amount
                                                            )} <br/><br/>`;
                          });
                          return (
                            <Row key={index + 1}>
                              <Col lg={3} md={12}>
                                {index === 0 ? (
                                  <img
                                    src={`http://photos.hotelbeds.com/giata/bigger/${img}`}
                                    alt={habBol?.name || "Habitación"}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                      borderRadius: "10px",
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.src = imgPreview;
                                      e.currentTarget.alt = "Imagen de hotel";
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      borderRadius: "10px",
                                      visibility: "hidden",
                                    }}
                                    onError={(e) => {
                                      e.currentTarget.src = imgPreview;
                                      e.currentTarget.alt = "Imagen de hotel";
                                    }}
                                  ></div>
                                )}
                              </Col>
                              <Col lg={9}>
                                <Row>
                                  <Col lg={3}>
                                    <div className="detail-hotel pt-3 p-3">
                                      <span className="name-hotel text-secondary">
                                        {habBol.name}
                                      </span>
                                      <br />
                                      <div className="pt-4">
                                        <span className="font-select-room text-secondary">
                                          {rate?.cantidadHabitaciones}{" "}
                                          {rate?.cantidadHabitaciones > 1
                                            ? "Habitaciones"
                                            : "Habitación"}{" "}
                                          para
                                        </span>

                                        <br />
                                        <span
                                          className="font-select-room pt-5"
                                          style={{
                                            fontWeight: "500",
                                            color: "#0044aa",
                                          }}
                                        >
                                          <FaMale />
                                          {rate?.adultos} Adulto(s)
                                        </span>
                                        <br />
                                        <span
                                          className="font-select-room"
                                          style={{
                                            fontWeight: "500",
                                            color: "#0044aa",
                                          }}
                                        >
                                          <FaChild />
                                          {rate?.menores} Menor(es)
                                        </span>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col lg={6}>
                                    <div className="section-meal  p-3">
                                      <span className="meal text-secondary">
                                        {rate?.planAlimenticio}
                                      </span>
                                      <p className="text-secondary">
                                        Menores gratis de 0 a 2 años
                                      </p>
                                      <div className="section-nights">
                                        <span
                                          className="font-select-room"
                                          style={{ fontWeight: "500" }}
                                        >
                                          {rate?.reembolsable === false ? (
                                            <span style={{ color: "#0044aa" }}>
                                              <MdOutlineCancel color="#0044aa" />{" "}
                                              No Reembolsable
                                            </span>
                                          ) : (
                                            <span className="text-success">
                                              <MdCheck color="green" />{" "}
                                              Reembolsable
                                            </span>
                                          )}
                                        </span>
                                      </div>
                                      <div
                                        className="section-nights  text-secondary pt-2"
                                        style={{ textAlign: "justify" }}
                                      >
                                        <span className="font-select-room">
                                          A partir del{" "}
                                          <strong
                                            style={{
                                              textDecoration: "underline",
                                            }}
                                          >
                                            {FormatCancellationPolicies(
                                              rate?.politicas?.[0]?.from
                                            )}
                                          </strong>
                                          , será aplicada una penalidad por
                                          cancelación por la cantidad de{" "}
                                          <strong>
                                            {Currency(
                                              rate?.politicas?.[0]?.amount
                                            )}{" "}
                                            MXN
                                          </strong>
                                          . Fecha y hora calculados en base a la
                                          hora local en destino.
                                        </span>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    lg={3}
                                    xs={12}
                                    sm={6}
                                    className="hotel_img d-lg-flex"
                                  >
                                    <div className="text-secondary font-select-room text-start text-lg-end p-3">
                                      <div className="section-nights">
                                        <span>
                                          {nights > 1
                                            ? `${nights} noches`
                                            : `${nights} noche`}
                                          ,{" "}
                                          {totalRooms[0]?.num_adultos +
                                            totalRooms[0]?.num_menores >
                                          1
                                            ? `${
                                                totalRooms[0]?.num_adultos +
                                                totalRooms[0]?.num_menores
                                              } personas`
                                            : `${
                                                totalRooms[0]?.num_adultos +
                                                totalRooms[0]?.num_menores
                                              } persona`}
                                        </span>
                                      </div>
                                      <div>
                                        <span
                                          className="location-hotel text-secondary text-start"
                                          style={{ fontSize: "16px" }}
                                        >
                                          Precio por noche
                                          <br />
                                          {comisionUsuario?.hoteleria && (
                                            <>
                                              <span
                                                style={{
                                                  fontSize: "13px",
                                                  color: "#8e8e8e",
                                                  textDecoration:
                                                    "line-through",
                                                }}
                                              >
                                                {Currency(
                                                  totalPrices(
                                                    rate?.total,
                                                    markup,
                                                    nights
                                                  )[0]
                                                )}{" "}
                                                MXN
                                              </span>
                                              <br />
                                            </>
                                          )}
                                          {Currency(
                                            totalPrices(
                                              rate?.total,
                                              markup,
                                              nights,
                                              comisionUsuario?.hoteleria
                                            )[0]
                                          )}{" "}
                                          <span style={{ fontSize: "12px" }}>
                                            {" "}
                                            MXN
                                          </span>
                                        </span>
                                        <br />
                                        <span
                                          className="font-select-room"
                                          style={{ fontSize: "18px" }}
                                        >
                                          Precio total:
                                        </span>
                                        <br />
                                        <p
                                          style={{
                                            fontSize: "25px",
                                            color: "rgb(57 100 171)",
                                          }}
                                          className="location-hotel"
                                        >
                                          {comisionUsuario?.hoteleria && (
                                            <>
                                              <span
                                                style={{
                                                  fontSize: "23px",
                                                  color: "#8e8e8e",
                                                  textDecoration:
                                                    "line-through",
                                                }}
                                              >
                                                {Currency(
                                                  totalPrices(
                                                    rate?.total,
                                                    markup,
                                                    nights
                                                  )[1]
                                                )}{" "}
                                                MXN
                                              </span>
                                              <br />
                                            </>
                                          )}
                                          {Currency(
                                            totalPrices(
                                              rate?.total,
                                              markup,
                                              nights,
                                              comisionUsuario?.hoteleria
                                            )[1]
                                          )}{" "}
                                          <span style={{ fontSize: "16px" }}>
                                            {" "}
                                            MXN
                                          </span>
                                        </p>
                                        <p>Impuestos incluidos*</p>
                                      </div>

                                      <Col
                                        xs={12}
                                        style={{
                                          paddingTop: "5px",
                                          paddingBottom: "5px",
                                        }}
                                      >
                                        <Button
                                          type="submit"
                                          data-img={`http://photos.hotelbeds.com/giata/bigger/${img}`}
                                          onClick={(e) =>
                                            actualizarDatos(
                                              rate,
                                              habBol?.name,
                                              hotels?.[0]?.nombre,
                                              hotels?.[0]?.destino,
                                              timeNights,
                                              totalRooms,
                                              rates?.[0]?.bol?.categoria,
                                              hotels?.[0]?.id_atv3,
                                              rates?.[0]?.bol?.moneda,
                                              habBol?.code, // Este es el identificador único
                                              hotels?.[0]?.codigo_pais,
                                              e?.target?.dataset?.img,
                                              nights,
                                              1,
                                              [
                                                location?.pathname,
                                                location?.search,
                                              ],
                                              totalPrices(
                                                rate?.total,
                                                markup,
                                                nights,
                                                comisionUsuario?.hoteleria
                                              )[1],
                                              rate?.total,
                                              politicasText,
                                              rates?.[0]?.bol.codigoDestino,
                                              index + 1
                                            )
                                          }
                                          disabled={
                                            addRoomLoader ===
                                            `${habBol?.code}-${index + 1}`
                                          }
                                          className="btn-blue btn-select-room fw-bolder p-2 text-center"
                                          style={{
                                            fontSize: "14px",
                                            height: "100%",
                                            borderRadius: "15px",
                                            width: "100%",
                                          }}
                                        >
                                          {addRoomLoader ===
                                          `${habBol?.code}-${index + 1}` ? (
                                            <div style={{ width: "100%" }}>
                                              <span
                                                className={"loader-hab"}
                                              ></span>
                                            </div>
                                          ) : (
                                            "Seleccionar Habitación"
                                          )}
                                        </Button>
                                      </Col>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          );
                        })}
                      </Card>
                    </div>
                  )}
                  {habHdo?.MealPlans?.MealPlan?.RateDetails && (
                    <div className="" key={index}>
                      <Card className="shadow-box mt-2 p-2">
                        <Row key={index + 1}>
                          <Col lg={3} md={12}>
                            {/* <div> */}
                            <img
                              src={
                                imgHdo
                                  ? imgHdo
                                  : `http://photos.hotelbeds.com/giata/bigger/${img}`
                              }
                              className="hotel-img"
                              alt="image-destinations"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "10px",
                              }}
                              onError={(e) => {
                                e.currentTarget.src = imgPreview;
                                e.currentTarget.alt = "Imagen de hotel";
                              }}
                            />
                            {/* <img
                                src={
                                  imgHdo
                                    ? imgHdo
                                    : `http://photos.hotelbeds.com/giata/bigger/${img}`
                                }
                                className="hotel-img"
                                alt="image-destinations"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                }}
                              /> */}
                            {/*  </div> */}
                          </Col>
                          <Col lg={9}>
                            <Row>
                              <Col lg={3}>
                                <div className="detail-hotel pt-3 p-3">
                                  <span className="name-hotel text-secondary">
                                    {habHdo?.Name}
                                  </span>
                                  <br />
                                  <div className="pt-4">
                                    <span className="font-select-room text-secondary">
                                      1 Habitación para
                                    </span>

                                    <br />
                                    <span
                                      className="font-select-room pt-5"
                                      style={{
                                        fontWeight: "500",
                                        color: "#0044aa",
                                      }}
                                    >
                                      <FaMale />
                                      {totalRooms[0]?.num_adultos} Adulto(s)
                                    </span>
                                    <br />
                                    <span
                                      className="font-select-room"
                                      style={{
                                        fontWeight: "500",
                                        color: "#0044aa",
                                      }}
                                    >
                                      <FaChild />
                                      {totalRooms[0]?.num_menores} Menor(es)
                                    </span>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="section-meal  p-3">
                                  <span className="meal text-secondary">
                                    {habHdo?.MealPlans?.MealPlan?.Name}
                                  </span>
                                  <p className="text-secondary">
                                    Menores gratis de 0 a 2 años
                                  </p>
                                  <div className="section-nights">
                                    <span
                                      className="font-select-room"
                                      style={{ fontWeight: "500" }}
                                    >
                                      {habHdo?.MealPlans?.MealPlan
                                        ?.RateDetails[0]?.CancellationPolicy
                                        ?.IsNonRefundable === "true" ? (
                                        <span style={{ color: "#0044aa" }}>
                                          <MdOutlineCancel color="#0044aa" /> No
                                          Reembolsable
                                        </span>
                                      ) : (
                                        <span className="text-success">
                                          <MdCheck color="green" /> Reembolsable
                                        </span>
                                      )}
                                    </span>
                                  </div>
                                  {habHdo?.MealPlans?.MealPlan?.RateDetails[0]
                                    ?.CancellationPolicy && (
                                    <div
                                      className="section-nights  text-secondary pt-2"
                                      style={{ textAlign: "justify" }}
                                    >
                                      <span className="font-select-room">
                                        A partir del{" "}
                                        <strong
                                          style={{
                                            textDecoration: "underline",
                                          }}
                                        >
                                          {FormatDate(
                                            habHdo?.MealPlans?.MealPlan
                                              ?.RateDetails[0]
                                              ?.CancellationPolicy?.NoShow
                                              ?.DateFrom
                                          )}
                                        </strong>
                                        , será aplicada una penalidad por
                                        cancelación por la cantidad de{" "}
                                        <strong>
                                          {Currency(
                                            habHdo?.MealPlans?.MealPlan
                                              ?.RateDetails[0]
                                              ?.CancellationPolicy?.NoShow
                                              ?.Amount
                                          )}{" "}
                                          MXN
                                        </strong>
                                        . Fecha y hora calculados en base a la
                                        hora local en destino.
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </Col>
                              <Col
                                lg={3}
                                xs={12}
                                sm={6}
                                className="hotel_img d-lg-flex"
                              >
                                <div className="text-secondary font-select-room text-start text-lg-end p-3">
                                  <div className="section-nights">
                                    <span>
                                      {nights > 1
                                        ? `${nights} noches`
                                        : `${nights} noche`}
                                      ,{" "}
                                      {totalPersons?.adultos +
                                        totalPersons?.menores >
                                      1
                                        ? `${
                                            totalPersons?.adultos +
                                            totalPersons?.menores
                                          } personas`
                                        : `${
                                            totalPersons?.adultos +
                                            totalPersons?.menores
                                          } persona`}
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      className="location-hotel text-secondary text-start"
                                      style={{ fontSize: "16px" }}
                                    >
                                      Precio por noche
                                      <br />
                                      {comisionUsuario?.hoteleria && (
                                        <>
                                          <span
                                            style={{
                                              fontSize: "13px",
                                              color: "#8e8e8e",
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            {Currency(
                                              totalPrices(
                                                habHdo?.MealPlans?.MealPlan
                                                  ?.RateDetails[0]?.Total,
                                                markup,
                                                nights
                                              )[0]
                                            )}{" "}
                                            MXN
                                          </span>
                                          <br />
                                        </>
                                      )}
                                      {Currency(
                                        totalPrices(
                                          habHdo?.MealPlans?.MealPlan
                                            ?.RateDetails[0]?.Total,
                                          markup,
                                          nights,
                                          comisionUsuario?.hoteleria
                                        )[0]
                                      )}{" "}
                                      <span style={{ fontSize: "12px" }}>
                                        {" "}
                                        MXN
                                      </span>
                                    </span>
                                    <br />
                                    <span
                                      className="font-select-room"
                                      style={{ fontSize: "18px" }}
                                    >
                                      Precio total:
                                    </span>
                                    <br />
                                    <p
                                      className="location-hotel"
                                      style={{
                                        fontSize: "25px",
                                        color: "rgb(57 100 171)",
                                      }}
                                    >
                                      {comisionUsuario?.hoteleria && (
                                        <>
                                          <span
                                            style={{
                                              fontSize: "23px",
                                              color: "#8e8e8e",
                                              textDecoration: "line-through",
                                            }}
                                          >
                                            {Currency(
                                              totalPrices(
                                                habHdo?.MealPlans?.MealPlan
                                                  ?.RateDetails[0]?.Total,
                                                markup,
                                                nights
                                              )[1]
                                            )}{" "}
                                            MXN
                                          </span>
                                          <br />
                                        </>
                                      )}
                                      {Currency(
                                        totalPrices(
                                          habHdo?.MealPlans?.MealPlan
                                            ?.RateDetails[0]?.Total,
                                          markup,
                                          nights,
                                          comisionUsuario?.hoteleria
                                        )[1]
                                      )}{" "}
                                      <span style={{ fontSize: "16px" }}>
                                        {" "}
                                        MXN
                                      </span>
                                    </p>
                                    <p>Impuestos incluidos*</p>
                                  </div>

                                  <Col
                                    style={{
                                      paddingTop: "5px",
                                      paddingBottom: "5px",
                                    }}
                                  >
                                    <Button
                                      type="submit"
                                      data-img={imgHdo ? imgHdo : img}
                                      onClick={(e) =>
                                        actualizarDatos(
                                          habHdo,
                                          habHdo?.Name,
                                          hotels?.[0]?.nombre,
                                          hotels?.[0]?.destino,
                                          timeNights,
                                          totalRooms,
                                          rates?.[0]?.bol?.categoria,
                                          hotels?.[0]?.id_atv3,
                                          rates?.[0]?.bol?.moneda,
                                          habHdo?.Id, // Este es el identificador único
                                          hotels?.[0]?.codigo_pais,
                                          e?.target?.dataset?.img,
                                          nights,
                                          1,
                                          [
                                            location?.pathname,
                                            location?.search,
                                          ],
                                          totalPrices(
                                            habHdo?.MealPlans?.MealPlan
                                              ?.RateDetails[0]?.Total,
                                            markup,
                                            nights,
                                            comisionUsuario?.hoteleria
                                          )[1],
                                          habHdo?.MealPlans?.MealPlan
                                            ?.RateDetails[0]?.Total,
                                          politicasTextHdo,
                                          rates?.[0]?.bol?.codigoDestino,
                                          index + 1
                                        )
                                      }
                                      disabled={
                                        addRoomLoader ===
                                        `${habHdo?.Id}-${index + 1}`
                                      }
                                      className="btn-blue fw-bolder btn-select-room p-2 text-center"
                                      style={{
                                        fontSize: "14px",
                                        borderRadius: "15px",
                                        width: "100%",
                                      }}
                                    >
                                      {addRoomLoader ===
                                      `${habHdo?.Id}-${index + 1}` ? (
                                        <div style={{ width: "100%" }}>
                                          <span className={"loader-hab"}></span>
                                        </div>
                                      ) : (
                                        "Seleccionar Habitación"
                                      )}
                                    </Button>
                                  </Col>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Card>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </>
        ) : (
          <></>
        )}
        {/* {rates?.[0]?.habitaciones?.map((habitacion, index) => (
          <div className="py-5" key={index}>
            <Card className="shadow-box mt-2 p-3">
              {habitacion?.rates?.map((rate, index) => (
                <Row key={index + 1}>
                  <Col lg={3}>
                    <div>
                      <img
                        src={hotel1}
                        className="hotel-img"
                        alt="image-destinations"
                        style={{
                          width: "100%",
                          height: "220px",
                          objectFit: "cover",
                          borderRadius: "15px",
                        }}
                      />
                    </div>
                  </Col>
                  <Col lg={9}>
                    <Row>
                      <Col lg={4}>
                        <div className="detail-hotel pt-3 p-3">
                          <span className="name-hotel text-secondary">
                            {habitacion.name}
                          </span>
                          <br />
                          <div className="pt-4">
                            <span className="font-select-room text-secondary">
                              {"1"} Habitación para:
                            </span>

                            <br />
                            <span
                              className="font-select-room text-danger pt-5"
                              style={{ fontWeight: "500" }}
                            >
                              <FaMale />
                              {"1"} {" Adulto "}
                            </span>
                            <br />
                            <span
                              className="font-select-room text-danger"
                              style={{ fontWeight: "500" }}
                            >
                              <FaChild />
                              {"0"}
                              {"Niños"}
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="section-meal  p-3">
                          <span className="meal text-secondary">
                            {"Todo Incluido"}
                          </span>
                          <p className="text-secondary">
                            Menores gratis de 0 a 2 años
                          </p>
                          <div className="section-nights">
                            <span
                              className="font-select-room"
                              style={{ fontWeight: "500" }}
                            >
                              <span className="text-danger">
                                <MdOutlineCancel color="red" /> No Reembolsable
                              </span>
                            </span>
                          </div>
                          <div className="section-nights  text-secondary pt-2">
                            <span className="font-select-room">
                              A partir del{" "}
                              <strong style={{ textDecoration: "underline" }}>
                                {"Rate"}
                              </strong>
                              , será aplicada una penalidad por cancelación por
                              la cantidad de <strong>{"rate MXN"}</strong>.
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col
                        lg={4}
                        className="hotel_img d-flex justify-content-around"
                      >
                        <div className="text-secondary font-select-room text-end p-3">
                          <div className="section-nights">
                            <span>Habitación por noche</span>
                          </div>
                          <div>
                            <span
                              className="location-hotel text-danger text-start"
                              style={{ fontSize: "30px" }}
                            >
                              {"$1000.00 MXN"}
                            </span>
                            <br />
                            <span className="font-select-room">
                              Precio total:
                            </span>
                            <br />
                            <p>{"$0,000.00 MXN"}</p>
                          </div>

                          <Col
                            style={{ paddingTop: "5px", paddingBottom: "5px" }}
                          >
                            <Button
                              type="submit"
                                onClick={() => handleShowModalHab(rateHab.code)} className="btn-blue btn-select-room p-2 text-center"
                              style={{
                                fontSize: "14px",
                                height: "35px",
                                borderRadius: "15px",
                                width: "100%",
                              }}
                            >
                              Seleccionar habitación
                            </Button>
                          </Col>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ))}
            </Card>
          </div>
        ))} */}
      </div>
      <div className="section-about-hotel container py-5">
        <Row>
          {/* Columna Izquierda: Tabs */}
          {hotels?.map((hotel, index) => (
            <Col md={8} key={index}>
              <Tab.Container defaultActiveKey="description">
                <Nav variant="pills" className="flex-column">
                  <Nav.Item>
                    <Nav.Link
                      className="border-bottom"
                      onClick={() => toggleTab("description")}
                      aria-controls="description"
                      aria-expanded={openTab === "description"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "1.5rem",
                        color: "black",
                      }}
                    >
                      <FaInfoCircle
                        style={{ marginRight: "10px", color: "#3864AB" }}
                      />
                      <span style={{ width: "100%" }}>
                        Descripción del Hotel
                      </span>
                      <span
                        style={{
                          color: "#3864AB",
                          marginLeft: "10px",
                          transition: "all 1.5s ease-out",
                        }}
                      >
                        {openTab === "description" ? "\u25B2" : "\u25BC"}
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Collapse appear={true} in={openTab === "description"}>
                    <Card body>
                      <Row className="p-2">
                        <Col lg={12} className="mb-5">
                          <h5 className="fs-3" style={{ color: "#0044aa" }}>
                            El Hotel
                          </h5>
                          <p
                            style={{
                              color: "#696a6c",
                              fontSize: "20px",
                              textAlign: "justify",
                            }}
                          >
                            {hotel?.descripcion}
                          </p>
                        </Col>
                        {hotels?.[0]?.punto_interes?.length > 0 && (
                          <Col lg={6} md={6}>
                            <Row>
                              <h5 className="fs-3" style={{ color: "#0044aa" }}>
                                Puntos de interés
                              </h5>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                {hotels?.[0]?.punto_interes?.map(
                                  (punto, index) => (
                                    <p
                                      key={index + 1}
                                      style={{
                                        fontSize: "20px",
                                        color: "#696a6c",
                                      }}
                                    >
                                      {punto?.punto_interes}
                                    </p>
                                  )
                                )}
                              </Col>
                              <Col
                                lg={6}
                                md={6}
                                sm={6}
                                xs={6}
                                style={{ borderLeft: "1px solid #696a6c" }}
                              >
                                {hotels?.[0]?.punto_interes?.map(
                                  (punto, index) => (
                                    <p
                                      key={index + 1}
                                      style={{
                                        fontSize: "20px",
                                        color: "#696a6c",
                                      }}
                                    >
                                      {punto?.distancia} mts
                                    </p>
                                  )
                                )}
                              </Col>
                            </Row>
                          </Col>
                        )}
                        <Col lg={6} md={6}>
                          <h5 className="fs-3" style={{ color: "#0044aa" }}>
                            Ubicación
                          </h5>
                          <p
                            style={{
                              fontSize: "20px",
                              color: "#696a6c",
                              margin: "0",
                            }}
                          >
                            Categoría: {rates?.[0]?.categoria}
                          </p>
                          <p
                            style={{
                              fontSize: "20px",
                              color: "#696a6c",
                              margin: "0",
                            }}
                          >
                            País: {hotels?.[0]?.pais_nombre}
                          </p>
                          <p
                            style={{
                              fontSize: "20px",
                              color: "#696a6c",
                              margin: "0",
                            }}
                          >
                            Destino: {hotels?.[0]?.destino}
                          </p>
                          <p
                            style={{
                              fontSize: "20px",
                              color: "#696a6c",
                              margin: "0",
                            }}
                          >
                            Zona: {rates?.[0]?.zona}
                          </p>
                          <p
                            style={{
                              fontSize: "20px",
                              color: "#696a6c",
                              margin: "0",
                            }}
                          >
                            Dirección: {hotels?.[0]?.direccion}
                          </p>
                        </Col>
                      </Row>
                    </Card>
                  </Collapse>

                  <Nav.Item>
                    <Nav.Link
                      className="border-bottom"
                      onClick={() => toggleTab("amenities")}
                      aria-controls="amenities"
                      aria-expanded={openTab === "amenities"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "1.5rem",
                        color: "black",
                        transition: "transform 2.3s ease-in-out",
                      }}
                    >
                      <FaListAlt
                        style={{ marginRight: "10px", color: "#3864AB" }}
                      />
                      <span style={{ width: "100%" }}>Amenidades</span>
                      <span
                        style={{
                          color: "#3864AB",
                          marginLeft: "10px",
                          display: "inline-block",
                          transition: "transform 2.3s ease-in-out",
                        }}
                      >
                        {openTab === "amenities" ? "\u25B2" : "\u25BC"}
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Collapse in={openTab === "amenities"}>
                    <Card body>
                      <Row className="p-2">
                        <Col lg={4}>
                          <ul style={{ color: "#696a6c", fontSize: "20px" }}>
                            {hotels?.[0]?.servicios
                              ?.slice(0, 20)
                              ?.map((servicio, index) => (
                                <li key={index + 1}>{servicio?.servicio}</li>
                              ))}
                          </ul>
                        </Col>

                        <Col lg={4}>
                          <ul style={{ color: "#696a6c", fontSize: "20px" }}>
                            {hotels?.[0]?.servicios
                              ?.slice(20, 40)
                              ?.map((servicio, index) => (
                                <li key={index + 1}>{servicio?.servicio}</li>
                              ))}
                          </ul>
                        </Col>
                        <Col
                          lg={4}
                          style={{ color: "#696a6c", fontSize: "20px" }}
                        >
                          <ul style={{ color: "#696a6c", fontSize: "20px" }}>
                            {hotels?.[0]?.servicios
                              ?.slice(40, 60)
                              ?.map((servicio, index) => (
                                <li key={index + 1}>{servicio?.servicio}</li>
                              ))}
                          </ul>
                        </Col>
                        <Col
                          lg={4}
                          style={{ color: "#696a6c", fontSize: "20px" }}
                        >
                          <ul style={{ color: "#696a6c", fontSize: "20px" }}>
                            {hotels?.[0]?.servicios
                              ?.slice(60, 80)
                              ?.map((servicio, index) => (
                                <li key={index + 1}>{servicio?.servicio}</li>
                              ))}
                          </ul>
                        </Col>
                      </Row>
                    </Card>
                  </Collapse>

                  <Nav.Item>
                    <Nav.Link
                      className="border-bottom"
                      onClick={() => toggleTab("tripadvisor")}
                      aria-controls="tripadvisor"
                      aria-expanded={openTab === "tripadvisor"}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "1.5rem",
                        color: "black",
                      }}
                    >
                      <FaStar
                        style={{ marginRight: "10px", color: "#3864AB" }}
                      />
                      <span style={{ width: "100%" }}>Tripadvisor</span>
                      <span style={{ color: "#3864AB", marginLeft: "10px" }}>
                        {openTab === "tripadvisor" ? "\u25B2" : "\u25BC"}
                      </span>
                    </Nav.Link>
                  </Nav.Item>
                  <Collapse in={openTab === "tripadvisor"}>
                    <Card body>
                      <iframe
                        title="tripadvisor"
                        style={{ width: "100%", height: "640px" }}
                        id="trip-ad"
                        src={`https://www.tripadvisor.com/WidgetEmbed-cdspropertydetail?display=true&partnerId=6CA95E2409844D6183003CEFCDDC2BDE&lang=es&locationId=${hotels?.[0]?.id_nativo_bol}`}
                      ></iframe>
                    </Card>
                  </Collapse>
                </Nav>
              </Tab.Container>
            </Col>
          ))}
          <Col md={4} className="d-flex justify-content-center p-0">
            <Container
              className="d-flex justify-content-center p-0"
              style={{ position: "relative" }}
            >
              <div style={{ position: "relative" }}>
                <img
                  src={bannerAyuda}
                  alt="Imagen con botones"
                  style={{
                    width: "100%",
                    height: "850px",
                    display: "block",
                    objectFit: "contain",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "430px",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                  }}
                >
                  <Row>
                    <Col className="pb-2 px-3">
                      <Button
                        href="tel:9982189740"
                        className="btn-blue"
                        style={{ width: "100%", borderRadius: "3rem" }}
                        variant="primary"
                      >
                        <BsFillTelephoneFill /> Llama ahora{" "}
                      </Button>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Button
                        className="btn-blue"
                        style={{ width: "220px", borderRadius: "3rem" }}
                        variant="secondary"
                        onClick={handleShow}
                      >
                        <FaPhoneVolume /> Agenda una llamada
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
      <Modal show={show} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Contáctanos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GeneralForm
            urlSection={location.pathname + location.search}
            isContactForm={true}
            isRentalCarForm={false}
          />
        </Modal.Body>
      </Modal>
      {similarHoteles?.length >= 4 && (
        <div className="section-cards-hotel container py-0 py-sm-5 py-lg-5">
          <div className="d-flex justify-content-between mt-0 mt-sm-5 mt-lg-5 align-items-center mb-4 container">
            <h3 className="text-lg-start text-center fw-bold title-home pb-3 mb-4 border-1 border-black border-bottom hotel-ideal">
              Los mejores hoteles de la zona
            </h3>
            <h5
              className="title-home d-lg-flex d-none text-start"
              style={{ fontSize: "30px", width: "30rem" }}
            >
              Llega a otros rincones y experimenta algo nuevo con estos hoteles
            </h5>
          </div>

          <Row>
            <Slider {...settingsInfoHotel} className="hotels-slider">
              {similarHoteles?.map((dataHotel, index) => {
                return (
                  <Col
                    lg={4}
                    md={4}
                    sm={12}
                    key={index + 1}
                    className="d-flex justify-content-center pt-4 mb-5"
                  >
                    <CardCarrousel
                      dataInfo={dataHotel}
                      nights={nights}
                      markup={markup}
                      seccion={"infoHotel"}
                      selectedDates={selectedDates}
                    />
                  </Col>
                );
              })}
            </Slider>
          </Row>
        </div>
      )}

      <CheckOutCart
        setAlert={setShowAlert}
        showAlert={showAlert}
        setAlertMessage={"Se agrego una nueva habitación"}
        arrDatos={arrSession}
      />
    </div>
  );
};
